import { Component } from '@angular/core';

@Component({
  selector: 'app-content-card4',
  imports: [],
  templateUrl: './content-card4.component.html',
  styleUrl: './content-card4.component.scss'
})
export class ContentCard4Component {

}
